__turbopack_context__.v({
  "sticky": "SidebarSticky-module-sass-module__KRWEGG__sticky",
  "wrapper": "SidebarSticky-module-sass-module__KRWEGG__wrapper",
});
